<div *ngIf="isNewVersion; else version1" class="dashboard_item card" [ngClass]="getClassName()" [class.process-item-btn]="hasViewLink">

  <div class="dashboard_item__infos" (click)="getLinkView()">
    <div *ngIf="getItemValue(2)" class="badge badge-secondary badge-pill">
      {{ getItemValue(2) }}
    </div>
    <div class="dashboard_item__infos__title">
      <p *ngIf="getItemValue(1); else noContent">{{ getItemValue(1) }}<span *ngIf="getItemValue(4)"> - {{ getItemValue(4) }}</span></p>
      <ng-template #noContent><p>Sem Título</p></ng-template>
    </div>
    <div class="dashboard_item__infos__task">
      <p><b>{{ getFirstTask() }}</b> na fase <b>{{ getCurrentStepName() }}.</b></p>
    </div>
  </div>
  <div *ngIf="hasActions" class="dashboard_item__link">
    <div class="btn-group">
      <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-ellipsis-v"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
          <ul>
            <li *ngFor="let link of getLinks()">
              <a
                href="javascript:;"
                (click)="chooseMode(link)"
                aria-expanded="true">
                  <i class="fa" [ngClass]="getOptionClassName(link)"></i>
                  <span>{{ link.key }}</span>
              </a>
            </li>
          </ul>
      </div>
    </div>
  </div>
</div>

<ng-template #version1>
  <div class="process-item"  [ngClass]="getClassName()">
    <div class="process-item__row_v1">
      <p *ngIf="getItemValue(1); else noContent">{{ getItemValue(1) }}</p>
      <ng-template #noContent><p>Sem Título</p></ng-template>
      <p *ngIf="getItemValue(2)" class="subtitle">{{ getItemValue(4) }}</p>
    </div>
    <div class="process-item__row_v1">
      <p>{{ getItemValue(2) }}</p>
    </div>
    <div class="process-item__row_v1">
      <div class="status badge badge-pill">
        {{ getStatus() }}
      </div>
    </div>
    <div class="process-item__row_v1" style="width: 82px;">
      <a *ngFor="let link of getLinks()"
        href="javascript:;"
        (click)="chooseMode(link)"
        class="btn btn-outline-secondary btn-icon"
        aria-expanded="true">
          <i class="fa" [ngClass]="getOptionClassName(link)"></i>
      </a>
    </div>
  </div>
</ng-template>